<div class="homeSideBar">
    <div class="homeLoginArea">
        <span class="homeSideBarHeader" [innerHTML]="'ACCOUNT_PROFILE_TITLE' | translate"></span>
        <div class="formPagesContent editList">
            <ul style="padding-left:0px">
                <li>
                    <span class="editListItemHeader" [innerHTML]="'ACCOUNT_PROFILE_NAME_SURNAME' | translate"></span>
                    <span class="editListItemName">{{accountInfo.userName}}</span>
                    <i class="icon icon-edit" (click)="changeName()" type="button"></i>
                </li>
                <li>
                    <span class="editListItemHeader" [innerHTML]="'ACCOUNT_PROFILE_PHONE_NUMBER' | translate"></span>
                    <span class="editListItemName">{{accountInfo.phone}}</span>
                </li>
                <li>
                    <span class="editListItemHeader" [innerHTML]="'ACCOUNT_PROFILE_PASSWORD' | translate"></span>
                    <span class="editListItemName">******</span>
                    <i class="icon icon-edit" (click)="changePin()" type="button"></i>
                </li>
                <li>
                    <span class="editListItemHeader" [innerHTML]="'ACCOUNT_PROFILE_EMAIL' | translate"></span>
                    <span class="editListItemName">{{accountInfo.email}}</span>
                    <i class="icon icon-edit" (click)="changeEmail()" type="button"></i>
                </li>
            </ul>
        </div>
    </div>
    <app-download-app></app-download-app>
</div>